import React from 'react';
import { TranslatedMessage } from '../../translation';
import { TLCode } from '../../../../common/enums';
import { HTMLInputProps, ITextAreaProps, TextArea } from '@blueprintjs/core';
import { Overwrite } from '../../../../typings/typings';

// tslint:disable-next-line:no-empty-interface
interface CommonTextAreaProps extends ITextAreaProps {}

export type TextAreaProps = Overwrite<CommonTextAreaProps, { placeholder?: TLCode | string }> &
  Overwrite<HTMLInputProps, { placeholder?: TLCode | string }>;

const renderTextArea = ({
  fill = true,
  className,
  ...otherInputGroupProps
}: CommonTextAreaProps & HTMLInputProps = {}) => <TextArea {...otherInputGroupProps} fill={fill} />;

const TextAreaInput = ({ placeholder, ...otherProps }: TextAreaProps) =>
  typeof placeholder === 'number' ? (
    <TranslatedMessage id={placeholder as TLCode}>
      {(tanslatedPlaceholder) => renderTextArea({ ...otherProps, placeholder: tanslatedPlaceholder })}
    </TranslatedMessage>
  ) : (
    renderTextArea({ ...otherProps, placeholder: placeholder as string })
  );

export default TextAreaInput;
